import VueSplide from "@splidejs/vue-splide";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap/scss/bootstrap.scss'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import "@splidejs/splide/dist/css/splide.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

Vue.use(VueSplide);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

Vue.filter("MOMENT", function (value) {
  return moment(value).add(30, "minutes").format("HH:mm");
});

Vue.filter("MOMENT_ESP", function (value) {
  return moment(value, "HH:mm").add(30, "minutes").format("HH:mm");
});

import VueNumberInput from "@chenfengyuan/vue-number-input";

Vue.use(VueNumberInput);

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
Vue.use(DatePicker);

import money from "v-money";
Vue.use(money);

const moment = require("moment");
require("moment/locale/pt-br");

Vue.use(require("vue-moment"), {
  moment,
});

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

import "../node_modules/nprogress/nprogress.css";

Vue.config.productionTip = false;

import VueGtm from "@gtm-support/vue2-gtm";

Vue.use(VueGtm, {
  id: "GTM-K4SSL3L",
  defer: false,
  compatibility: false,
  enabled: true,
  loadScript: true,
  vueRouter: router,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
